import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { ActionIcon, Anchor, Drawer, Flex, Image, Text } from '@mantine/core';
import { creatorActions } from '@/store/slices/creatorSlice';
import { RichText } from '@/components/ui/richText/RichText';
import ArrowLeftIcon from '@/assets/icons/arrowLeft.svg?react';

export const CreatorHelpDrawer: FC = () => {
	const dispatch = useTypedDispatch();

	const { options } = useTypedSelector((state) => state.creator);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ helpDrawerOpened: false }));
	};

	return (
		<Drawer
			opened={options.helpDrawerOpened}
			onClose={handleClose}
			title={
				<Flex gap="sm">
					<ActionIcon onClick={handleClose} variant="transparent">
						<ArrowLeftIcon />
					</ActionIcon>
					<Text size="lg" fw="bold">
						{options.helpDrawerData?.title}
					</Text>
				</Flex>
			}
		>
			<Image
				src={options.helpDrawerData?.image}
				mb="md"
				mah={300}
				fit="cover"
			/>

			<Text size="sm" my="lg" c="dimmed" span>
				<RichText raw={options.helpDrawerData?.description || ''} />
			</Text>
			<Flex mt="lg" justify="space-between">
				{!!options.helpDrawerData?.shopUrl && (
					<Anchor
						href={options.helpDrawerData.shopUrl}
						target="_blank"
						rel="noopener noreferrer"
						display="block"
						c="black"
						underline="always"
						fw="bold"
					>
						Zobacz w sklepie
					</Anchor>
				)}
			</Flex>
		</Drawer>
	);
};
